import styled from 'styled-components'

export const TemplateList = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 2px;
`
